import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { BankingService } from 'src/app/services/banking/banking.service';
import { LoadingService } from 'src/app/shared/loading/loading.service';
import { RemoveAccountNameWarningDialogComponent } from '../remove-account-name-warning-dialog/remove-account-name-warning-dialog.component';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-account-name-dialog',
  templateUrl: './account-name-dialog.component.html',
  styleUrls: ['./account-name-dialog.component.scss'],
})
export class AccountNameDialogComponent {
  displayName: FormControl;

  constructor(
    public dialogRef: MatDialogRef<AccountNameDialogComponent>,
    private bankingService: BankingService,
    private loadingService: LoadingService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.displayName = new FormControl(this.data.displayName || '', [
      Validators.minLength(4),
      Validators.maxLength(50),
      Validators.pattern(/^[a-zA-Z0-9 -]+$/)
    ]);
  }

  get isFormInvalid(): boolean {
    return this.displayName.invalid;
  }

  get isRemoveButtonDisabled(): boolean {
    return (
      this.data.displayName === '' ||
      this.data.displayName === null ||
      this.data.displayName === undefined
    );
  }

  onClick(action: string): any {
    const accountIndex = this.data.accountIndex;
    const displayName = this.displayName.value;

    this.loadingService.initializeLoading();

    switch (action) {
      case 'remove':
        const removeAccountDialog = this.dialog.open(
          RemoveAccountNameWarningDialogComponent,
          {
            width: '620px',
            height: '256px',
          }
        );

        removeAccountDialog
          .afterClosed()
          .pipe(
            switchMap((result) => {
              if (result === 'confirm') {
                return this.bankingService
                  .setDisplayName(accountIndex, '')
                  .pipe(
                    switchMap(() =>
                      of({ status: 'Display name removed successfully' })
                    )
                  );
              } else {
                return of(result);
              }
            })
          )
          .subscribe({
            next: (response) => {
              if (response.status === 'Display name removed successfully') {
                Swal.fire("Sucesso", "Apelido removido com sucesso!", "success");
                this.dialogRef.close(response);
                this.loadingService.finalizeLoading();
              }
              this.loadingService.finalizeLoading();
            },
            error: (err) => {
              this.dialogRef.close({
                status: 'error',
                message: 'Erro ao remover o nome desta conta',
              });
              this.loadingService.finalizeLoading();
            },
          });

        break;

      case 'save':
        this.bankingService
          .setDisplayName(accountIndex, displayName)
          .subscribe({
            next: (response) => {
              this.dialogRef.close(response);
              this.loadingService.finalizeLoading();
            },
            error: (err) => {
              this.dialogRef.close({
                status: 'error',
                message: 'Erro ao definir um nome para esta conta',
              });
              this.loadingService.finalizeLoading();
            },
          });
        break;

      default:
        this.dialogRef.close('Canceled by user');
        this.loadingService.finalizeLoading();
        break;
    }
  }

  onCancel(): void {
    this.dialogRef.close('Canceled by user');
  }

  getFormattedAccount(): string {
    return this.data.accountIndex ? this.data.accountIndex.split('-')[2].slice(0, -1) + '-' + this.data.accountIndex.split('-')[2].slice(-1) : 'MASTER';
  }

}
